import enviro from 'enviro';
export const getDebugLogger = service => ({
  debug: message => {
    if (!enviro.debug(service)) {
      return;
    }
    /* eslint-disable no-console */


    console.debug(`[debug: ${service}]: \t\t${message}`);
  }
});